import {Component, inject} from '@angular/core';
import {NzIconDirective} from 'ng-zorro-antd/icon';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {Router} from '@angular/router';
import {NzDividerComponent} from 'ng-zorro-antd/divider';
import {NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent} from 'ng-zorro-antd/form';
import {NzInputDirective, NzInputGroupComponent} from 'ng-zorro-antd/input';
import {NzColDirective, NzRowDirective} from 'ng-zorro-antd/grid';
import {NonNullableFormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {OrganizationService} from '@services/organization/organization.service';

@Component({
  selector: 'app-organization-form',
  imports: [
    NzIconDirective,
    NzButtonComponent,
    NzDividerComponent,
    NzFormItemComponent,
    NzFormControlComponent,
    NzInputGroupComponent,
    NzRowDirective,
    NzColDirective,
    ReactiveFormsModule,
    NzInputDirective,
    NzFormDirective,
    NzFormLabelComponent
  ],
  templateUrl: './organization-form.component.html',
  styleUrl: './organization-form.component.scss'
})
export class OrganizationFormComponent {

  private router = inject(Router);
  private fb = inject(NonNullableFormBuilder);
  private organizationService = inject(OrganizationService);

  loading = false;

  validateForm = this.fb.group({
    name: this.fb.control('', [Validators.required]),
    address: this.fb.control('', [Validators.required]),
    email: this.fb.control('', [Validators.required, Validators.email]),
    phone: this.fb.control('', [Validators.required]),
    website: this.fb.control('', [Validators.required, Validators.pattern('https?://.+')]),
  });

  goBack() {
    this.router.navigate(['/organization']);
  }

  submitForm() {
    this.loading = true;
    this.organizationService.createNewOrganization(this.validateForm.value)
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          this.router.navigate(['/organization', res.id]);
        },
        error: (error) => {
          this.loading = false;
          console.error('Error creating organization:', error);
        }
      });
  }
}
